import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";
import { usePracticeSettings } from "features/practice/hooks/usePracticeSettings";

const useHealthlinkPractice = () => {
  const tenant =
    useSelector((state) => state.auth.user?.tenant) ||
    localStorage.getItem("kinesin-tenant");
  const { data: practiceSettings } = usePracticeSettings();
  const isHealthlinkEnabled =
    !!practiceSettings && practiceSettings.healthLink !== false;

  const fetchHealthlinkPractice = async () => {
    const axiosInstance = createAxiosInstance();

    try {
      const response = await axiosInstance.get(`${tenant}/healthlink/practice`);

      return response.data;
    } catch (error) {
      // A tenant may simply have no HealthLink practice configured (e.g. a
      // surgery that only does manual vaccinations). That is a valid state,
      // not an error — return null so consumers can degrade gracefully
      // instead of surfacing a global toast.
      if (error?.response?.status === 404) {
        return null;
      }

      throw error;
    }
  };

  return useQuery({
    queryKey: ["healthlinkPractice", tenant],
    queryFn: fetchHealthlinkPractice,
    enabled: !!tenant && isHealthlinkEnabled,
    retry: false,
    meta: { skipGlobalError: true },
  });
};

export { useHealthlinkPractice };